<template>
  <ul>
    <li class="bbs" v-for="(question, index) in status" :key="index">
      <router-link :to="'/question/' + question.idx">
        <p class="title">
          {{ question.title }}
          <slot name="refresh" />
        </p>
        <p>
          <span class="date">{{ $moment(question.uploadAt).fromNow() }}</span>
          <span
            class="status"
            :class="question.answer ? 'cl-green' : 'cl-red'"
          >{{ question.answer ? '답변 완료' : '처리 중' }}</span>
        </p>
        <i class="arrow right" />
      </router-link>
    </li>
  </ul>
</template>
<script>
export default {
  name: "DashboardCard",
  props: ["status"]
};
</script>